import { makeStyles } from "@material-ui/core"

export const loadAssetsStyle = makeStyles((theme) => ({
    listWrapper: {
        overflow: 'auto'
    },
    card: {
        padding: '1em',
    },
    emptyPlaceHolder: {
        margin: '-1rem'
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        fontWeight: '400'
    }
}));